<template>
  <validation-observer ref="step2">
    <b-form>
      <b-alert variant="danger" show v-if="!appid || appid.length === 0">
      <h4 class="alert-heading">Facebook App ID is not set</h4>
      <div class="alert-body">
        <span>Please set the Facebook App ID in the</span>
        <b-link to="/account-setting" class="mx-1">Marketing Settings</b-link>
      </div>
    </b-alert>
    <b-row class="mb-2 justify-content-end">
      <!-- <b-col md="4">
        <b-form-select
          v-model="selectedSocialMedia"
          :options="socialMediaOptions"
        ></b-form-select>
      </b-col> -->
    </b-row>
 <!-- Facebook Login -->
 <!-- <div
      class="facebook__login card p-3 text-center bg-info"
      v-if="appid && appid.length > 0"
    >
      <div class="text">
        <h3 class="text-white">Facebook Login</h3>
        <p class="text-white">Login with Facebook to view all your posts</p>
        <div id="app" class="d-flex justify-content-center">
          <v-facebook-login
            :app-id="firstAppId"
            v-model="model"
            @sdk-init="handleSdkInit"
            @login="onLogin"
            @logout="logout"
          ></v-facebook-login>
        </div>
      </div>
    </div> -->

    <!-- Instagram Login -->
    <!-- <div
      class="instagram__login card p-3 text-center bg-instagram"
      v-if="selectedSocialMedia === 'instagram'"
    >
      <div class="text">
        <h3 class="text-white">Instagram Login</h3>
        <p class="text-white">Login with Instagram to view all your posts</p>
        <div id="" class="d-flex justify-content-center">
          <b-button variant="btn btn-instagram">
            <feather-icon icon="InstagramIcon" class="mr-50 text-white" />
            <span class="align-middle">Continue with Instagram</span>
          </b-button>
        </div>
      </div>
    </div> -->

    <!-- LinkedIn Login -->
     <!-- <div
      class="linkedin__login card p-3 text-center bg-linkedin"
      v-if="selectedSocialMedia === 'linkedin'"
    >
      <div class="text">
        <h3 class="text-white">LinkedIn Login</h3>
         <p class="text-white">Login with LinkedIn to view all your posts</p> -->
        <!-- <div id="app" class="d-flex justify-content-center"> -->
           <!-- <b-button variant="btn btn-black text-white"
           @click="loginWithLinkedIn" v-model="model" :app-id="firstAppId" @sdk-init="handleSdkInit_LN">
            <feather-icon icon="InstagramIcon" class="mr-50 text-white" />
            <span class="align-middle">Continue with LinkedIn</span>
          </b-button>  -->
           <!-- <b-button
          variant="btn btn-black text-white"
          @click="loginLinkedIn"
        >
          <feather-icon icon="LinkedInIcon" class="mr-50 text-white" />
          <span class="align-middle">Continue with LinkedIn</span>
        </b-button>  -->
          
           <!-- <v-linkedin-login
            :app-id="firstAppId"
            v-model="model"
            @sdk-init="handleSdkInit_LN"
            @login="onLoginLN"
            @logout="logout"
          ></v-linkedin-login>  -->
         <!-- </div>
      </div>
    </div>  -->

      <b-row>
        <b-col cols="3">
          <b-card class="shadow-none border">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="facebookChecked"></b-form-checkbox>
                <h4 class="mb-0">Facebook</h4>
              </div>
              <div>
                <feather-icon icon="FacebookIcon" class="text-info" size="25" />
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="3">
          <b-card class="shadow-none border">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="instagramChecked"></b-form-checkbox>
                <h4 class="mb-0">Instagram</h4>
              </div>
              <div>
                <feather-icon
                  icon="InstagramIcon"
                  class="text-danger"
                  size="25"
                />
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="3">
          <b-card class="shadow-none border">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="linkedinChecked"></b-form-checkbox>
                <h4 class="mb-0">LinkedIn</h4>
              </div>
              <div>
                <feather-icon
                  icon="LinkedinIcon"
                  class="text-info text-darken-2"
                  size="25"
                />
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="3">
          <b-card class="shadow-none border">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="EventChecked"></b-form-checkbox>
                <h4 class="mb-0">Event</h4>
              </div>
              <div>
                <!-- <feather-icon
                  icon="EventIcon"
                  class="text-info text-darken-2"
                  size="25"
                /> -->
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="12">
          <!-- <h4>Post Details</h4> -->
          <!-- <b-form-checkbox
            v-if="facebookChecked && instagramChecked && linkedinChecked"
            name="check-button"
            class="mb-2"
            switch
            inline
            v-model="isSwitchChecked"
          >
            Customise post for Facebook, Instagram, and LinkedIn
          </b-form-checkbox>
          <b-form-checkbox
            v-else-if="facebookChecked && instagramChecked"
            name="check-button"
            class="mb-2"
            switch
            inline
            v-model="isSwitchChecked"
          >
            Customise post for Facebook and Instagram
          </b-form-checkbox>
          <b-form-checkbox
            v-else-if="facebookChecked && linkedinChecked"
            name="check-button"
            class="mb-2"
            switch
            inline
            v-model="isSwitchChecked"
          >
            Customise post for Facebook and LinkedIn
          </b-form-checkbox>
          <b-form-checkbox
            v-else-if="instagramChecked && linkedinChecked"
            name="check-button"
            class="mb-2"
            switch
            inline
            v-model="isSwitchChecked"
          >
            Customise post for Instagram and LinkedIn
          </b-form-checkbox>
          <b-form-checkbox
            v-if="EventChecked"
            name="check-button"
            class="mb-2"
            switch
            inline
            v-model="isSwitchChecked"
          >
            Events
          </b-form-checkbox> -->
          <b-tabs>
            <b-tab v-if="facebookChecked" title="Facebook">
              <b-form-group
                label="Facebook Post"
                label-for="description"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Facebook Post"
                  vid="Description"
                >
                  <quill-editor
                    v-model="campaignId.description"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <b-form-group v-if="facebookChecked" class="mb-1">
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="date and time"
                  vid="scheduledPublishedDate"
                >
                  <div class="d-flex align-items-end mb-1">
                    <feather-icon
                      icon="FacebookIcon"
                      class="text-info"
                      size="18"
                    />
                    <h5 class="ml-1 mb-0">Facebook</h5>
                  </div>
                  <b-form-datepicker
                    v-model="campaignId.scheduledPublishedDate"
                    id="form-control"
                    placeholder="Choose a date"
                    local="en"
                    :initial-date="new Date()"
                    :min="today"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              </b-form-group>
            </b-tab>
            <b-tab v-if="instagramChecked" title="Instagram">
              <b-form-group
                label="Instagram Post"
                label-for="description"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Instagram Post"
                  vid="Description"
                >
                  <quill-editor
                    v-model="campaignId.description"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-tab>
            <b-tab v-if="linkedinChecked" title="LinkedIn">
              <b-form-group
                label="LinkedIn Post"
                label-for="description"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="LinkedIn Post"
                  vid="Description"
                >
                  <quill-editor
                    v-model="campaignId.description"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-tab>
            <b-tab v-if="EventChecked" title="Events">
              <b-row>
                <b-col cols="12" class="d-flex justify-content-start my-1">
                  <b-button variant="primary"  @click="showModal">Add Task</b-button>
                </b-col>
              </b-row>
              <b-table :items="eventsTaskslist"
            :fields="tasks_fields"
            striped
            responsive>
              <template #cell(assignee)="data">
                <span> {{ getAssigneeName(data.item.assignee) }}</span>
              </template>
              <template #cell(startDate)="data">
                    {{ formatDate(data.item.startDate) }}
                  </template>
                  <template #cell(endDate)="data">
                    {{ formatDate(data.item.endDate) }}
                  </template>

        <template #cell(status)="row">
            <div class="d-flex align-items-center" v-if="!row.item.editingStatus"
              @click="editField(row.item, 'editingStatus')">
              <b-badge :variant="getStatusColor(row.item.status)">{{
                row.item.status
              }}</b-badge>

              <feather-icon icon="EditIcon" class="ml-2" />
            </div>
            
            <div v-else>
              <b-form-select v-model="row.item.status" :options="statusOptions"
                @change="saveField(row.item, 'editingStatus')" />
            </div>
          </template>

              </b-table>
            </b-tab>
          </b-tabs>
          
          <b-form-group v-if="!facebookChecked && !instagramChecked && linkedinChecked == false && !EventChecked" label="Description" label-for="description">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="email content"
              vid="Description"
            >
              <quill-editor
                v-model="campaignId.description"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col v-if="facebookChecked || instagramChecked || linkedinChecked || (EventChecked === false)" md="12">
          <div class="demo-inline-spacing">
            <b-button size="sm"
            variant="primary" 
            @click="drafting('draft')"
            >
            Save as Draft
          </b-button>

          <b-button size="sm"
            variant="primary" 
            @click="publish('sendNow')"
            >
            Send Now
          </b-button>

          <b-button size="sm"
            variant="primary" 
            @click="schedule('schedule')"
            >
            Schedule Post
          </b-button>
          </div>
        </b-col>

        <!-- date and time -->
        
      </b-row>
    </b-form>

    <b-modal ref="modalAddTasks" id="modal-add-tasks" title="Add New Task"
                    @hide="resetForm" hide-footer centered>
                    <validation-observer ref="addTaskForm" v-slot="{ invalid, validate }">
                        <b-form @submit.prevent="validate().then((success) => success && addTasks())">
                            <b-form-group label="Task" label-for="task">
                                <validation-provider name="Task" rules="required" v-slot="{ errors }">
                                    <b-form-input id="task" v-model="newtasks.task" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="Assignee" label-for="assignee">
                                <validation-provider name="Assignee" rules="required" v-slot="{ errors }">
                                  <b-form-select id="assignee" 
                                      v-model="newtasks.assignee" 
                                      :options="employeeList" 
                                      value-field="id"
                                      text-field="firstName"
                                      required />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="Budget" label-for="budget">
                                <validation-provider name="Budget" rules="required" v-slot="{ errors }">
                                    <b-form-input id="budget" v-model="newtasks.budget" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="Status" label-for="status">
                                <validation-provider name="Status" rules="required" v-slot="{ errors }">
                                    <b-form-select id="status" v-model="newtasks.status" :options="statusOptions"/>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group label="StartDate" label-for="startDate">
                                <validation-provider name="StartDate" rules="required" v-slot="{ errors }">
                                    <b-form-datepicker
                      id="example-datepicker"
                      v-model="newtasks.startDate"
                      :min="today"
                      date-format="yyyy-MM-dd"
                      class="mb-1"
                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <b-form-group label="EndDate" label-for="endDate">
                                <validation-provider name="EndDate" rules="required" v-slot="{ errors }">
                                    <b-form-datepicker
                      id="example-datepicker1"
                      v-model="newtasks.endDate"
                      :min="today"
                      date-format="yyyy-MM-dd"
                      class="mb-1"
                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <b-button type="submit" variant="primary" :disabled="invalid">
                                Add Tasks
                            </b-button>
                        </b-form>
                    </validation-observer>
                </b-modal>
  </validation-observer>

</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BFormFile,
  BFormRadio,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BCardText,
  BFormCheckbox,
  BCard,
  BModal,
  BTabs,
  BTable,
  BTab,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import { required, email } from "@validations";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
//import PostDetails from "./PostDetails.vue";
import PostDetails from "../PostDetails.vue";
import FaqQuestionAnswer from "../FaqQuestionAnswer.vue";
import VFacebookLogin from "vue-facebook-login-component";
import {
  getProviderName,
  createProvider,
  deleteProvider,
  getProviders,
  testsmtp,
  updateProvider,
} from "@/store/smtp/services";
import { FormWizard, TabContent } from "vue-form-wizard";
import { quillEditor } from "vue-quill-editor";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import CampaignDetails from "./CampaignDetails.vue";
import { url } from "@/@core/utils/validations/validations";
export default {
  name: "AddCampaign",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BFormRadio,
    vSelect,
    quillEditor,
    flatPickr,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BCardText,
    BFormCheckbox,
    BCard,
    BTabs,
    BTable,
    BModal,
    BTab,
    FormWizard,
    TabContent,
    CampaignDetails,
    FeatherIcon,
    PostDetails,
    FaqQuestionAnswer,
    VFacebookLogin
  },
  data() {
    return {
      id: this.$route.params.id,
      facebookImage:
        "https://cdn.pixabay.com/photo/2021/08/16/08/55/facebook-6549798_1280.jpg",
      facebookAppId: "",
      linkedInAppId: "",
      model: {},
      facebookToken: "",
      linkedInToken: "",
      FB: {},
      LN: {},
      fb: null,
      ln: null,
      beakerToken: "AQWgFwxOoekI_d4T8PRLwu3GJ72yrN21nRUTJH2xhPqVVDF9OUc89sTYqDOSS-RNQ7whMaaDVoNO5hekETroJgDlS_EQ1a2zgtsBGQD-PQri0cR2iM4bZFGlNsZjSmQ2mnZgXePP4L6JukgwwSITZ7eWLtwUZ3rJ1ruJLJwBHyvGbRTKdOyRaxtAbTqM6jdy25AthVX6vo7swRRt0O0-8bH-ocr9RXdO-X-GTLZsVOPdUVq6m5wjKvBxfw1hZc4SwYs-kSoCNA9Qj2owg65MkxZ5yZFstFBKINpy42rhhaLnARC3faruypfzhdMkzHpHVLdknLUYPrpQ4xCjAOTJ23o8VFEtzw",
      fbtoken: "EAAT3ftTClHEBO1LazeYMQXIq2e7cH1ax2B8CETehP5CEC1ZBEsBhsAy7neqBvFNVxWfBz2wkgA1nUfbk36og6BU6TWR3rtZA7cq5teaVjfrqxH0KXfHD8X43ZADGg9aWg4SY8kXx1AudF03dK7SszVDZCAOLYnVbZArz4dYOQ1xAQ9j6YxDTtb0HM2AZDZD",
      scope: {},
      instagramLoggedIn: false,
      facebookLoggedIn: false,
      linkedInLoggedIn: false,
      collapsed: false,
      accounts: [],
      instagramAccounts: [],
      media: [],
      mainLoading: false,
      imageFiles: [],
      imagePreviews: [],
      emailtemplatelist: [],
      selectedProvider: null,
      selectedTemplateId: null,
      selectedTemplate: [],
      Selected: "A",
      smtp: [],
      Selected1: "c",
      SelectedRadio: "D", // Default to "Save as Draft"
      showDateSelector: false,
      schedulePlatform: null,
      date: null,
      //dateNtim: null,
      //eventsTaskslist: [],
      content_visible: {
        facebook: this.collapsed,
        instagram: this.collapsed,
        linkedin: this.collapsed,
      },
      selectedSocialMedia: null,
      // socialMediaOptions: [
      //   { value: "facebook", text: "Facebook" },
      //   // { value: "instagram", text: "Instagram" },
      //   { value: "linkedin", text: "LinkedIn" },
      // ],
      selected: [{ title: "Segment 1" }, { title: "Segment 2" }],
      descriptionFacebook: '',
      descriptionInstagram: '',
      descriptionLinkedIn: '',
      content: "",
      name: "",
      budget: null,
      plannedBudget: null,
      startDate: null,
      endDate: null,
      subject: "",
      scheduledPublishedDate: null,
      file: null,
      selectedSegments: [],
      segmentOptions: [],
      required,
      postdetails: [],
      linkedinChecked: false,
      facebookChecked: false,
      instagramChecked: false,
      EventChecked: false,
      isEventChecked: false,
      isSwitchChecked: false,
      facebookContent: "",
      instagramContent: "",
      linkedinContent: "",
      selectedTasks: [],
      tasks_fields: [
  //     { key: 'select', label: '', sortable: false, formatter: (value, key, item) => {
  //     return `<input type="checkbox" v-model="selectedTasks" :value="item.id" />`;
  // }},
        { key: "task", label: "Tasks" },
        { key: "assignee", label: "Assignee" },
        { key: "budget", label: "Budget" },
        { key: "startDate", label: "Start Date" },
        { key: "endDate", label: "End Date" },
        { key: "status", label: "Status" },
      ],
      newtasks: {
                task: null,
                assignee: null,
                budget: null,
                startdate: null,
                enddate: null,
                status: null,
            },
      statusOptions: [
      { value: "PENDING", text: "PENDING" },
        { value: "BLOCKED", text: "BLOCKED" },
        { value: "PUBLISHED", text: "PUBLISHED" },
        { value: "COMPLETED", text: "COMPLETED" },
        { value: "CANCELLED", text: "CANCELLED" },
      ],
    };
  },

  created() {
    const code = this.$route.query.code; // Get the code from the URL
    if (code) {
      this.getAccessToken(code);
    } else {
      this.error = 'No authorization code found.';
      this.loading = false;
    }
  },

  computed: {
    ...mapGetters("emailtemplate", {
      emailtemplate: "emailtemplate",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    ...mapGetters("emailcampaign", {
      emailcampaign: "emailcampaign",
      loading: "loading",
    }),
    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),
    ...mapGetters("marketingModule", {
      appid: "appid",
      campaignId: "campaignId",
      posts: "drafts",
      eventsTaskslist: "eventtasks",
      loadingMarketing: "loading",
    }),
    showSaveDraft() {
      return this.SelectedRadio === "D";
    },
    showSaveScheduled() {
      return this.SelectedRadio === "B";
    },
    showSendNow() {
      return this.SelectedRadio === "A";
    },
    today() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    firstAppId() {
      console.log('appid:', this.appid);
      return this.appid && this.appid.length > 0 ? this.appid[0].appId : null;
    },
  },
  methods: {
    ...mapActions("segmentModule", ["getSegmentsAction"]),
    ...mapActions("emailtemplate", ["getEmailTemplateListAction"]),
    ...mapActions("emailcampaign", ["addEmailCampaignAction"]),
    ...mapActions("employeeModule", [
      "getEmployeeListAction",
    ]),
    ...mapActions("marketingModule", [
      "getAppIdAction",
      "getPostAction",
      "removePostAction", "postFacebookAction", "postLinkedInAction", "postSocialAction",
      "postMarketingCampaignAction",
      "getMarketingCampaignByIDAction",
      "putMarketingCampaignAction",
      "getCampaignDraftListAction", "postCampaignDraftAction", 
      "getEventTaskListAction", "postEventTaskAction", "putEventTaskAction"
    ]),
    showModal() {
            this.$refs.modalAddTasks.show();
        },
    getAssigneeName(id) {
      const assign = this.employeeList.find((s) => s.id === id);
      return assign ? assign.firstName : "-";
    },

    editField(item, field) {
      this.$set(item, field, true);
    },

    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },

    getStatusColor(status) {
      switch (status) {
        case "PENDING":
          return "warning";
        case "BLOCKED":
          return "info";
        case "PUBLISHED":
          return "success";
          case "COMPLETED":
          return "success";
        case "CANCELLED":
          return "info";
        default:
          return "secondary";
      }
    },

    saveField(item, field) {
      this.$set(item, field, false);

      let payload = {
        id: item.id,
        status: item.status,
      };
      this.putEventTaskAction(payload);
        // .then(() => {
        //   this.successAdd();
        // })
        // .catch(error => {
        //   // Error handling
        //   this.errorAdd();
        //   console.error(error);
        // });
      this.fetchDetails();

    },
    onLogin(response) {

      this.FB.login((response) => {
        if (response.authResponse) {
      this.FB.api(
        "/me/accounts",
        "GET",
        { fields: "name,access_token,id" },
        (data) => {
          this.facebookToken = data.data[0].access_token;
          console.log("dataaaaaaaa", data.data);
          this.accounts = data;
          localStorage.setItem("facebookToken", this.facebookToken);
          this.getPostAction(this.facebookToken);
          for (let i = 0; i < data.data.length; i++) {
            const accountId = data.data[i].id;
            this.FB.api(
              accountId + "?fields=connected_instagram_account",
              (response) => {
                if (
                  response.connected_instagram_account &&
                  response.connected_instagram_account.id
                ) {
                  const instagramAccountId =
                    response.connected_instagram_account.id;
                  this.instagramAccounts = instagramAccountId;
                  this.FB.api(
                    instagramAccountId +
                      "?fields=biography,followers_count,follows_count,media_count,name,username,profile_picture_url,media",
                    (responseData) => {
                      this.media = responseData;
                      this.$emit("media", this.media);
                      // for each media item or post, get the following
                      for (let i = 0; i < responseData.media.data.length; i++) {
                        let mediaCount = responseData.media.data[i].id;
                        this.FB.api(
                          mediaCount +
                            "?fields=caption,like_count,media_type,media_url,timestamp,thumbnail_url,permalink,comments_count,id,ig_id,is_comment_enabled,is_shared_to_feed,media_product_type,owner,shortcode,username,comments{username,text}",
                          (responseMedia) => {
                            this.postdetails.push(responseMedia);
                            this.$emit("postdetails", this.postdetails);
                          }
                        );
                      }
                    }
                  );
                }
              }
            );
          }
        }
      );

      this.FB.api("/me", "GET", { fields: "name" }, (data) => {
        this.userId = data;


      });
      
      // Set facebookLoggedIn to true
      this.$emit("facebookLoggedIn", true);
    } else {
      console.log("User did not authorize login.");
    }
  }, {
    scope: 'public_profile,email,pages_show_list,pages_manage_posts,instagram_basic,pages_read_engagement' // Add the necessary permissions here
  });
},

    loginWithLinkedIn(response) {
      this.LN.api(
        "/me/accounts",
        "GET",
        { fields: "name,access_token,id" },
        (data) => {
          this.linkedInToken = data.data[0].access_token;
          console.log("dataaaaaaaa", data.data);
          this.accounts = data;
          localStorage.setItem("linkedInToken", this.linkedInToken);
          this.getPostAction(this.linkedInToken);
          
        }
      );

      this.LN.api("/me", "GET", { fields: "name" }, (data) => {
        this.userId = data;
      });
      // Set linkedInLoggedIn to true
      this.$emit("linkedInLoggedIn", true);
    },

    loginLinkedIn() {
       console.log("appiddd", this.appid.appId);
      // const client = (this.appid.appId || []).find((s) => s.platform === "LINKEDIN");
      const clientId = "789ulzg5szfrdw";
      const redirectUri = encodeURIComponent('https://www.linkedin.com/feed/');;
      const scope = 'profile email w_member_social ';
      const state = 'QwertyTest123!'; 

      const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=${scope}`;
      
      window.location.href = url; 
      console.log("appiddd", this.appid.appId);
    },


    logout() {
      window.location.reload();
    },

    handleSdkInit({ FB, scope }) {
      console.log("FB", FB);
      this.FB = FB;
      this.scope = 'public_profile,email,pages_show_list,pages_manage_posts,instagram_basic';
    },
    handleSdkInit_LN({ LN, scope }) {
      this.LN = LN;
      this.scope = scope;
    },

    handleLinkedInLoggedIn(value) {
      this.linkedInLoggedIn = value;
    },
    handleFacebookLoggedIn(value) {
      this.facebookLoggedIn = value;
    },
    handleInstagramLoggedIn(value) {
      this.instagramLoggedIn = value;
    },
    handlePostDetails(value) {
      this.postdetails = value;
    },

    emitAction(action) {
      this.$emit('action-selected', action); // Emit the selected action back to the parent
    },
    async drafting(action) {
      //this.$emit('action-selected', action);
      if(this.facebookChecked === true){
        this.schedulePlatform = "Facebook";
      }
      else if(this.instagramChecked === true){
        this.schedulePlatform = "Instagram";
      }
      else if(this.linkedinChecked === true){
        this.schedulePlatform = "LinkedIn";
      }

      this.campaignId.status = "DRAFT";
      this.saveDraft();
    },
    async publish(action) {
      if(this.facebookChecked === true){
        this.schedulePlatform = "Facebook";
      }
      else if(this.instagramChecked === true){
        this.schedulePlatform = "Instagram";
      }
      else if(this.linkedinChecked === true){
        this.schedulePlatform = "LinkedIn";

        // const payload = {
        //   content: this.campaignId.description,
        //   postLink: "https://www.linkedin.com/feed/",
        //   scheduleUnixTimeStamp: null,
        //   token: this.beakerToken
        // }
        // console.log("payloadlinkedin", payload);

        // await this.postLinkedInAction(payload);
        
        // this.$router.push({ name: "marketing-campaign-list" });
      }
      // console.log("platformssssssss", this.schedulePlatform);
      // console.log("test", this.facebookChecked);
      //   console.log("test1", this.linkedinChecked);
      //   console.log("test2", this.instagramChecked);
      this.campaignId.status = "COMPLETED";
      this.sendNow();
    },
    async schedule(action) {
      this.showDateSelector = true;
      
      if(this.facebookChecked === true){
        this.schedulePlatform = "Facebook";
      }
      else if(this.instagramChecked === true){
        this.schedulePlatform = "Instagram";
      }
      else if(this.linkedinChecked === true){
        this.schedulePlatform = "LinkedIn";
      }

      if(this.facebookChecked === false && this.linkedinChecked === false && this.instagramChecked === false){
        console.log("test", this.facebookChecked);
        console.log("test1", this.linkedinChecked);
        console.log("test2", this.instagramChecked);
        this.errordateNtime();
        return;
      }

      // if(this.campaignId.status !== "SCHEDULED"){
      //   this.errorStatus();
      //   return;
      // }

      console.log("platformPost", this.schedulePlatform);
      //return;
      
      this.saveScheduled();

    },

    showImagePreview(event) {
      this.imageFiles = [...event.target.files];
      this.imagePreviews = [];

      for (let file of this.imageFiles) {
        const reader = new FileReader();

        reader.onload = (e) => {
          this.imagePreviews.push(e.target.result);
        };

        reader.readAsDataURL(file);
      }
    },
    selectTemplate() {
      this.selectedTemplate = this.emailtemplate.find(
        (template) => template.templateId === this.selectedTemplateId
      );
    },

    errordateNtime() {
      this.$swal({
        title: "Error!",
        text: " Please select Facebook platform and a schedule date!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    errorStatus() {
      this.$swal({
        title: "Error!",
        text: "Status should be set to 'SCHEDULED'!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    toggleCollapse(platform) {
      this.content_visible[platform] = !this.content_visible[platform];
    },

    async formSubmitted(status) {
      
      console.log("statussss", status);
      
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the Campaign is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      const payload = {
        campaignId: this.id,
        name: this.campaignId.name,
        startDate: this.campaignId.startDate,
        endDate: this.campaignId.endDate,
        description: this.campaignId.description,
        subject: this.campaignId.name,
        budget: this.campaignId.budget,
        plannedBudget: this.campaignId.plannedBudget,

        status: status,
        templateId: this.selectedTemplateId,
        segmentId: this.selectedSegments.map((segment) => segment.value),
        campaignDrafts: [
          {
            campaignId: this.id,
            platform: this.schedulePlatform,
            content: this.campaignId.description,
            scheduledPublishedDate:
              status === "SCHEDULED"
                ? this.campaignId.scheduledPublishedDate
                : null,
            segmentId: this.selectedSegments.map((segment) => segment.value),
          },
        ],
        smtpSettingId: this.selectedProvider,
      };
             console.log("platform", this.schedulePlatform);
            // console.log("drafts", this.campaignId.scheduledPublishedDate);
      await this.putMarketingCampaignAction(payload)
        .then((response) => {
          loader.close();
          if (status === "SCHEDULED") {
            this.success(
              `Marketing Campaign successfully scheduled!`
            );
          } else {
            this.success("Marketing Campaign Updated!");
          }

          this.$router.push({ name: "marketing-campaign-list" });
        })
        .catch((ex) => {
          loader.close();
          this.error(ex.response.data);
        });
    },

    saveDraft() {
      this.formSubmitted("DRAFT");
    },
    success(message) {
      this.$swal({
        title: "Marketing Campaign",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    sendsuccess(response) {
      console.log("resp", response);
      this.$swal({
        
        title: "Marketing Campaign",
        text: response.data.message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },

    saveScheduled() {
      console.log("datesssssssssss", this.campaignId.scheduledPublishedDate);
      if (this.campaignId.scheduledPublishedDate === null) {
        this.errordateNtime();
        return;
      }

      // if (this.campaignId.scheduledPublishedDate) {
        this.formSubmitted("SCHEDULED");
      // } else {
      //   this.formSubmitted("DRAFT");
      // }
    },

    sendNow() {
      //if (this.SelectedRadio === "A") {
        if(this.linkedinChecked === true){
        this.schedulePlatform = "LinkedIn";

        const payload = {
          content: this.campaignId.description,
          //postLink: "string",
          //postLink: "https://www.linkedin.com/in/james-pean-5a56a9334/recent-activity/all/",
          //scheduleUnixTimeStamp: null,
          token: "string"
        }
        console.log("payloadlinkedin", payload);

         this.postLinkedInAction(payload).then((response) => {
          
        if (response.success) {
          
          this.sendsuccess(response);
        } else {
          console.log("testttt");
          this.sendsuccess(response);
          // this.formSubmitted("COMPLETED");
          console.error("LinkedIn Post Failed:", response);
        }
      })
      }
      else if (this.facebookChecked === true){
        this.schedulePlatform = "Facebook";

        const payload = {
          content: this.campaignId.description,
          // postLink: "",
          // scheduleUnixTimeStamp: null,
          token: this.fbtoken
        }
        console.log("payloadfacebook", payload);

         this.postSocialAction(payload).then((response) => {
        if (response.success) {
          this.sendsuccess();
        } else {
          
          console.log("testttt");
          this.sendsuccess(response);
          this.formSubmitted("COMPLETED");
        }
      })
      }
      this.formSubmitted("COMPLETED");
      
    },

    async getSMPT() {
      try {
        const response = await getProviders();
        this.smtp = response.data.result.map((smtp) => ({
          value: smtp.id,
          text: `${smtp.provider}`,
        }));
      } catch (error) {
        console.log(error);
      }
    },

    async addTasks(){
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the Task is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      const payload = {
        campaignId: this.id,
        task: this.newtasks.task,
        assignee: this.newtasks.assignee,
        status: this.newtasks.status,
        startDate: this.newtasks.startDate,
        endDate: this.newtasks.endDate,
        budget: this.newtasks.budget,
        isActive: true,
      }
//console.log("payload", payload);
      await this.postEventTaskAction(payload)
      .then((response) => {
          loader.close();
         
            this.success(
              `Task successfully added!`
            );
            this.$refs.modalAddTasks.hide();
          this.$router.push({ name: "marketing-draft-edit" });
        })
        .catch((ex) => {
          loader.close();
          this.error(ex.response.data);
        });

        // loader.close();
        // this.$bvModal.hide('modal-add-tasks');
        // this.success('Event Task added successfully.');
        
        await this.fetchDetails();
    },

async fetchDetails(){
 // console.log("token", this.$route.query.access_token);
  this.facebookToken = this.$route.query.access_token;
  this.linkedInToken = this.$route.query.access_token;
  const code = this.$route.query.code;
    const state = this.$route.query.state;

    if (code) {
      this.getAccessToken(code);
    }

    this.mainLoading = true;

    this.getAppIdAction().then(()=>{
      console.log("all appids", this.appid)
    });

    try {
      await this.getMarketingCampaignByIDAction(this.id);

      await this.getCampaignDraftListAction();

      const filteredDrafts = this.posts.filter(draft => draft.campaignId === this.id);
      
      if (filteredDrafts.length > 0) {
        this.campaignId.description = filteredDrafts[0].content; 
    }

    console.log("dddddddddddddddddd", this.campaignId.campaignDrafts[0].platform);
    if (this.campaignId.campaignDrafts[0].platform === "Facebook"){
          this.facebookChecked = true;
        }
        else if (this.campaignId.campaignDrafts[0].platform === "Instagram"){
          this.instagramChecked = true;
        }
        else if (this.campaignId.campaignDrafts[0].platform === "LinkedIn"){
          this.linkedinChecked = true;
        }

       
    console.log("fffffffffffffffffffff", this.facebookChecked);
    console.log("iiiiiiiiiiiiiiiii", this.instagramChecked);
    console.log("llllllllllllllllllll", this.linkedinChecked);

    // event tasks
    await this.getEmployeeListAction();
     await this.getEventTaskListAction()
    .then(() => {
        this.eventsTaskslist = this.eventsTasks.filter(
          (eventsTasks) => eventsTasks.campaignId === this.id
        );
        });
   
      await this.getEmailTemplateListAction().then(() => {
        this.emailtemplatelist = this.emailtemplate.map((template) => ({
          value: template.templateId,
          text: `${template.name}`,
        }));
      });
     

      await this.getSMPT();

      await this.getSegmentsAction().then(() => {
        this.segmentOptions = this.segments.map((segment) => ({
          value: segment.segmentId,
          itemTitle: `${segment.name}`,
        }));
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.mainLoading = false;
    }
}
  },

  async mounted() {
    await this.fetchDetails();

//     fetch('https://api.linkedin.com/v2/me', {
//   method: 'GET',
//   headers: {
//     'Authorization': `Bearer ${this.beakerToken}`
//   }
// })
// .then(response => response.json())
// .then(data => console.log(data))
// .catch(error => console.error(error));
  },
  watch: {
    startDate(newDate) {
      if (
        newDate &&
        this.endDate &&
        new Date(this.endDate) < new Date(newDate)
      ) {
        this.endDate = null; // Clear endDate if it is earlier than startDate
      }
    },
  },
};
</script>


<!-- <script>
  window.fbAsyncInit = function() {
    FB.init({
      appId      : '{your-app-id}',
      cookie     : true,
      xfbml      : true,
      version    : '{api-version}'
    });
      
    FB.AppEvents.logPageView();   
      
  };

  (function(d, s, id){
     var js, fjs = d.getElementsByTagName(s)[0];
     if (d.getElementById(id)) {return;}
     js = d.createElement(s); js.id = id;
     js.src = "https://connect.facebook.net/en_US/sdk.js";
     fjs.parentNode.insertBefore(js, fjs);
   }(document, 'script', 'facebook-jssdk'));
</script> -->

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
</style>
